module.exports = __webpack_public_path__ + "static/img/gf.7cc65efc.svg";